// Romaya user roles: super_admin (funnel Super Admin), admin (funnel admin), customer (or the old traveler).
// One helper so no screen checks the string "admin" on its own.

export const isAdminRole = (role) => role === "admin" || role === "super_admin";
export const isSuperAdminRole = (role) => role === "super_admin";

export const BANNED_MESSAGE = "Your account is banned. You can still read.";

// A banned user can read everything but every action answers 403 USER_BANNED (Phase 7, note 5).
// The API may flag the user in more than one way, so accept each.
export const isBannedUser = (user) =>
  Boolean(user && (user.isBanned === true || user.banned === true || user.bannedAt || user.status === "banned"));

export const isUserBannedError = (err) => Boolean(err && (err.code === "USER_BANNED" || err.error === "USER_BANNED"));

// Fired when any call answers USER_BANNED, so the banner shows even before the user object says so.
export const USER_BANNED_EVENT = "romaya:user-banned";
export function announceUserBanned() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(USER_BANNED_EVENT));
}
